<template>
    <div style="overflow: hidden;">
        <div class="container" ref="container">
            <img src="@/assets/home-three-icon1.png" />
        </div>
        <div class="container1">
            <div>
                <h1 class="wow animate__lightSpeedInLeft" data-wow-delay="0.1s">a difference</h1>
                <h3 class="wow animate__lightSpeedInLeft" data-wow-delay="0.2s">how did we make a difference?</h3>
            </div>
            <img src="@/assets/footerview/home-fff-icon1.png" />
            <div>
                <div class="wow animate__bounceInUp" data-wow-delay="0.1s">
                    <h5>CNN brasil</h5>
                    <p>Our roadmap included internal linking and technical “quick win” strategies designed to improve
                        crawl frequency, increase overall rankings, and influence the number of results that included
                        featured snippets.Our technical SEO audit prioritized recommendations to increase page speed and
                        the overall user-experience.</p>
                </div>
                <div class="wow animate__bounceInUp" data-wow-delay="0.2s">
                    <h5>Market Research</h5>
                    <p>Research showed us that Google rewarded (better ranking) different types of content for the
                        various keywords that we were targeting.</p>
                </div>
                <div class="wow animate__bounceInUp" data-wow-delay="0.3s">
                    <h5>Content</h5>
                    <p>Update and optimize articles using an “evergreen” approach – target articles that support
                        keywords with high search demand year-round.</p>
                </div>
            </div>
        </div>
        <div class="container2">
            <div>
                <div><img src="@/assets/footerview/footer-fff-icon2.png" width="100%" /></div>
                <div>
                    <h3 class="wow animate__fadeInRight">The Client</h3>
                    <p class="wow animate__fadeInRight" data-wow-delay="0.1s">CNN Brasil is the first news channel in
                        the country to debut first on digital and then on television.</p>
                    <p class="wow animate__fadeInRight" data-wow-delay="0.2s">With 24-hour multiplatform programming, it
                        is possible to follow CNN Brasil through the main pay-TV operators , through social networks ,
                        through Youtube, through podcast platforms, or even receive CNN content in your email every day
                        through newsletters.</p>
                </div>
            </div>

            <div>
                <div><img src="@/assets/footerview/footer-fff-icon3.png" width="100%" /></div>
                <div>
                    <h3 class="wow animate__fadeInLeft">The Solution</h3>
                    <p class="wow animate__fadeInLeft" data-wow-delay="0.1s">MYD partnered with the CNN marketing teams
                        to develop a holistic SEO and content strategy. Our efforts encompassed in-depth research,
                        on-page optimization,<br />targeted content development, best practice workshops, and the
                        implementation of technical SEO best practices at scale.</p>
                </div>
            </div>
        </div>

        <div class="container3">
            <div><img src="@/assets/footerview/footer-fff-icon4.png" width="70%" /></div>
            <div>
                <div v-for="(item, index) in accordionItems" :key="index" class="accordion-item"
                    :class="{ 'active': activeIndex === index }" @click="toggleAccordion(index)">
                    <div class="accordion-header">
                        <h3>{{ item.title }}</h3>
                    </div>
                    <div class="accordion-content" ref="accordionContents">
                        <p>{{ item.content }}</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="container4">
            <div>Our critical KPI was to help achieve 1 billion pageviews.CNN also aimed to increase the percentage of
                organic traffic compared to all other digital channels.</div>
            <div><img src="@/assets/footerview/footer-fff-icon5.png" /></div>
        </div>
        <div><img src="@/assets/footerview/footer-fff-icon6.png" width="80%" /></div>
    </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, nextTick } from 'vue';

const container = ref(null);
let observer = null;

const handleIntersection = (entries) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            entry.target.classList.add('clip-path-effect');
        } else {
            entry.target.classList.remove('clip-path-effect');
        }
    });
};

onMounted(() => {
    observer = new IntersectionObserver(handleIntersection, {
        threshold: 0.1 // 当元素 10% 进入视口时触发
    });
    if (container.value) {
        observer.observe(container.value);
    }
});

onUnmounted(() => {
    if (observer && container.value) {
        observer.unobserve(container.value);
    }
});

const activeIndex = ref(null);
const accordionContents = ref([]);

const accordionItems = [
    {
        title: 'Content curation',
        content: '50% of all pageviews originated from the organic search channel, a 91% increase in organic pageviews.'
    },
    {
        title: 'SEO Strategy',
        content: 'The total number of results returning featured snippets in Google increase by 79%.'
    },
];

const toggleAccordion = async (index) => {
    if (activeIndex.value === index) {
        activeIndex.value = null;
    } else {
        activeIndex.value = index;
    }
    await nextTick();
    setAccordionHeight(index);
};


const setAccordionHeight = (index) => {
    accordionContents.value.forEach((content, i) => {
        if (i === index && activeIndex.value === index) {
            content.style.maxHeight = content.scrollHeight + 'px';
        } else {
            content.style.maxHeight = '0px';
        }
    });
};
</script>

<style lang="less" scoped>
.container {
    background-image: url("../../assets/footerview/footer-fff-bg.png");
    min-height: 100vh;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: 50% 50%;
    -webkit-clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
    clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
    transition: clip-path 1s ease, -webkit-clip-path 1s ease; // 添加过渡效果
    position: relative;

    &.clip-path-effect {
        -webkit-clip-path: polygon(0 0, 100% 0, 100% 100%, 0 75%);
        clip-path: polygon(0 0, 100% 0, 100% 100%, 0 75%);
    }

    >img:nth-child(1) {
        width: 10vw;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
}

.container1 {
    position: relative;

    >div:nth-child(1) {
        text-align: left;
        text-transform: uppercase;

        h1 {
            color: rgba(10, 15, 56, .1);
            letter-spacing: 10px;
            font-size: 5vw;
            margin: 0px;
            padding: 0px;
            margin-top: -45px;
        }

        h3 {
            font-size: max(2vw, 14px);
            margin: 0px;
            padding: 0px;
            margin-top: -55px;
            margin-left: 20px;
        }
    }

    >img:nth-child(2) {
        position: absolute;
        right: 3%;
        width: 18%;
        transform: translateY(-65%);
    }

    >div:nth-child(3) {
        display: flex;
        flex-wrap: wrap;
        gap: 3%;
        margin: 15% 10% 10% 10%;

        >div {
            flex: 1;
            min-width: 200px;
            box-shadow: 0 1px 3px rgba(0, 0, 0, .12), 0 1px 2px rgba(0, 0, 0, .24);
            padding: 3% 2%;
            margin-bottom: 20px;
            color: #97a4be;
            font-weight: 300;
            line-height: 1.5;

            >h5 {
                color: #233148;
                font-size: max(1.5vw, 12px);
                margin: 3% 0%;
                text-transform: uppercase;
            }
        }
    }
}

.container2 {
    >div {
        display: flex;
        flex-wrap: wrap;
        background-color: #f5f6fa;
        text-align: left;
        font-family: Space Grotesk, sans-serif !important;

        >div:nth-child(1) {
            flex: 2;
            min-width: 300px;
        }

        >div:nth-child(2) {
            flex: 3;
            min-width: 300px;
            padding: 3%;
        }

        h3 {
            font-weight: 400;
            font-size: max(2vw, 14px);
        }

        p {
            line-height: 1.7;
            color: #1a2e42;
            font-weight: 300;
        }
    }

    >div:nth-child(2) {
        background-color: #fff;
        flex-direction: row-reverse;
    }
}

.container3 {
    display: flex;
    flex-wrap: wrap;
    width: 90%;
    margin: auto;

    >div {
        flex: 3;
        padding-top: 5%;
        min-width: 300px;

        img {
            width: 80%;
            z-index: 100;
            position: relative;
        }
    }

    >div:nth-child(2) {
        flex: 4;
        position: relative;
        z-index: 101;
        text-align: left;

        .accordion-item {
            background-color: #fff;
            color: #172d43;
            border: 1px solid #ddd;
            margin-bottom: 10px;
            cursor: pointer;
            padding: 3%;
            box-shadow: 0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12);
            transition: background-color 0.3s, color 0.3s;

            &.active {
                background-color: #0a0f38;
                color: #fff;
            }

            .accordion-header {
                >h3 {
                    margin: 0px;
                }
            }

            .accordion-content {
                overflow: hidden;
                max-height: 0;
                transition: max-height 0.3s ease-out;

                p {
                    padding: 20px 0px 10px 0px;
                    margin: 0px;
                }
            }
        }
    }
}

.container4 {
    display: flex;
    flex-wrap: wrap;
    position: relative;
    z-index: 99;

    &::before {
        position: absolute;
        width: 100%;
        height: 100%;
        top: -200px;
        left: 0;
        content: "";
        background-color: #f5f6fa;
        transform: skewY(10deg);
        z-index: 10;
    }

    color: #172d43;
    line-height: 1.5;
    padding: 7%;
    gap: 2%;
    font-weight: 400;
    font-size: max(2vw, 14px);
    text-align: left;

    >div {
        flex: 3;
        position: relative;
        z-index: 100;
        min-width: 300px;

        >img {
            width: 100%;
        }
    }

    >div:nth-child(2) {
        flex: 4;
    }
}

@media all and (max-width:600px) {
    .container {
        min-height: 0px;
        aspect-ratio: 5/9 !important;

        >img:nth-child(1) {
            top: 18%;
            left: 50%;
            width: 100px;
        }
    }

    .container1 {
        position: relative;

        >div:nth-child(1) {
            text-align: left;
            text-transform: uppercase;

            h1 {
                margin-top: -45px;
            }

            h3 {
                margin-top: -10px;
                margin-left: 0px;
            }
        }
        >img:nth-child(2) {
            position: absolute;
            right: 3%;
            width: 200px;
            transform: translateY(-110%);
        }
    }

    .container2 {
        width: 90%;
        margin: auto;
    }
}
</style>